<template>
  <button @click="action">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <path
        d="M0.999756 22.8749H18.9998"
        stroke="white"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.85669 10.722L9.99955 15.5832L15.1424 10.722"
        stroke="white"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99976 15.5832V0.999878"
        stroke="white"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: ["action"],
};
</script>

<style scoped>
button {
  cursor: pointer;
  border: none;
  background-color: #5a5ccd;
  width: 4rem;
  height: 4rem;
}
</style>